export default __webpack_public_path__ + "media/components/Profile/right-8f13109822b8a0d97644833072f6d71f.png";